export default {
  coupon: {},
};
